var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('TopBar'),_c('div',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.key})],1)],1),_c('Foot',{directives:[{name:"show",rawName:"v-show",value:(_vm.key != '/after'),expression:"key != '/after'"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }